import { render, staticRenderFns } from "./PictureDragDropPaste.vue?vue&type=template&id=b579801c"
import script from "./PictureDragDropPaste.vue?vue&type=script&lang=js"
export * from "./PictureDragDropPaste.vue?vue&type=script&lang=js"
import style0 from "./PictureDragDropPaste.vue?vue&type=style&index=0&id=b579801c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports